const suffixes = [
    { value: 1e12, symbol: "T" },
    { value: 1e9, symbol: "B" },
    { value: 1e6, symbol: "M" },
    { value: 1e3, symbol: "K" },
];

export const formatNumberShort = (n: number) => {
    const rule = suffixes.find(({ value }) => n >= value);
    if (!rule) return n.toString();

    const raw = n / rule.value;
    const rounded = Math.floor(raw * 10) / 10;
    const formatted = rounded.toString().replace(/\.0$/, "");
    return formatted + rule.symbol;
};
